import MapInstance from 'ol/Map';
import { Err, Ok } from 'ts-results';
// @ts-ignore
MapInstance.prototype.FindLayerById = function (id) {
    const maybeLayer = this.getLayers()
        .getArray()
        .find((layer) => layer.get('id') === id);
    // @ts-ignore
    return maybeLayer !== undefined ? Ok(maybeLayer) : Err(`No map layer found for ${id}`);
};
// @ts-ignore
MapInstance.prototype.RemoveLayerById = function (id) {
    const nonBaseLayers = this.getLayers()
        .getArray()
        .filter((val) => !val.get('basemap'));
    nonBaseLayers.forEach((layer) => {
        if (layer.get('id') === id) {
            this.removeLayer(layer);
        }
    });
};
// @ts-ignore
MapInstance.prototype.AddOnClickSelection = function (store, selectionLayer) {
    this.on('click', async function (e) {
        const selectedFeatures = new Map();
        selectionLayer.getSource()?.clear();
        store.dispatch('Identify/reset');
        // This is all for handling WMS Layers
        /* let wmsLayers = vm.map.getLayers().array_.filter((item) => item.getVisible() && item.getSource() instanceof TileWMS && !item.get('data').title.includes('Imagery'))
    
        let viewResolution = vm.view.getResolution()
        if (wmsLayers.length > 0) {
          for (let i = 0; i < wmsLayers.length; i++) {
            // Need a solution for arcgis layers with no returned geometry
            let url = wmsLayers[i].getSource().getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', { INFO_FORMAT: 'application/geojson', FEATURE_COUNT: 10 })
            // let url = wmsLayers[i].getSource().getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', { INFO_FORMAT: 'application/json' })
            if (url) {
              const { data, error } = await useAxiosGet(url)
              if (data?.features?.length > 0) {
                vm.$set(vm.selected, getUid(wmsLayers[i]), data.features)
                vm.selectionLayer.getSource().addFeatures(new GeoJSON().readFeatures(data))
              }
              if (error) {
                console.log('error')
                console.log(error)
              }
            }
          }
        } */
        // @ts-ignore
        this.forEachFeatureAtPixel(e.pixel, function (f, layer) {
            if (layer.get('id') !== selectionLayer.get('id')) {
                const title = layer.get('title');
                if (!selectedFeatures.get(title)) {
                    selectedFeatures.set(title, []);
                }
                selectionLayer.getSource()?.addFeature(f);
                selectedFeatures.get(title)?.push(f);
                store.dispatch('Identify/setData', selectedFeatures);
                store.dispatch('Identify/open');
            }
        });
    });
};
